var React = require('react');

function Layers (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.5 3.75L3.75 13.125L22.5 22.5L41.25 13.125L22.5 3.75Z","stroke":"#F9FAFC","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3.75 31.875L22.5 41.25L41.25 31.875","stroke":"#F9FAFC","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M3.75 22.5L22.5 31.875L41.25 22.5","stroke":"#F9FAFC","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Layers.defaultProps = {"width":"45","height":"45","viewBox":"0 0 45 45","fill":"none"};

module.exports = Layers;

Layers.default = Layers;
